const o = "Trường màu sắc, màu hiện tại là {color}", r = "Trường màu", c = "Bảng màu", l = "Màu đặt trước", t = "Màu đặt sẵn tùy chỉnh", e = "Thêm màu", n = "Xoá màu", s = "Màu tùy chỉnh, định dạng HEX", C = "Thêm màu vào danh sách các màu tùy chỉnh", m = "Xóa trường màu tùy chỉnh", u = "Delete color with backspace", d = {
  currentColor: o,
  emptyColor: r,
  palette: c,
  presetColors: l,
  customColors: t,
  addColor: e,
  clearColor: n,
  colorField: s,
  colorFieldConfirm: C,
  colorFieldClear: m,
  deleteColorDescriber: u
};
export {
  e as addColor,
  n as clearColor,
  s as colorField,
  m as colorFieldClear,
  C as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  d as default,
  u as deleteColorDescriber,
  r as emptyColor,
  c as palette,
  l as presetColors
};
